/** Copyright (c) 2022-present TVM Engineering Authors. */

// const dotenv = require('dotenv');
// dotenv.config();
//
// const IS_PROD = process.env.NODE_ENV === 'production';
const IS_PROD = undefined;
export const BASE_URL = IS_PROD ? process.env.REACT_APP_BASE_URL : 'localhost';
export const API_URL = IS_PROD ? process.env.REACT_APP_API_URL : '/api';
export const USER_LENGTH = 6;
export const MAX_PASS_LENGTH = 20;
export const MIN_PASS_LENGTH = 8;
export const ROLES = {
	USER: 'user',
	MANAGER: 'manager',
	ADMIN: 'admin',
	SUPER_ADMIN: 'super-admin',
};

export const USER_STATUS = {
	DELETED: 'deleted',
	ACTIVE: 'active',
	REGISTERED: 'registered',
	PENDING: 'pending',
	DISABLED: 'disabled'
};
